export enum StatusSincronizacao {
  PENDENTE = 'PENDENTE',
  SINCRONIZADO = 'SINCRONIZADO',
  ERRO = 'ERRO'
}

export enum StatusAtendimento {
  AGENDADO = 'AGENDADO',
  INICIADO = 'INICIADO',
  REALIZADO = 'REALIZADO',
  CANCELADO = 'CANCELADO'
}

